export const SET_ADMIN_BOOKINGS_LIST = 'SET_ADMIN_BOOKINGS_LIST';
export const SET_ADMIN_LISTINGS_LIST = 'SET_ADMIN_LISTINGS_LIST';
export const SET_ADMIN_USERS_LIST = 'SET_ADMIN_USERS_LIST';
